import { NoPayload } from '../commonPayloadTypes';

export enum ProfileMenuEvent {
    PreferencesClicked = 'ProfileMenuEvent.PreferencesClicked',
}

export interface ProfileMenuEventMap {
    [ProfileMenuEvent.PreferencesClicked]: NoPayload;
}
